import React from "react";
import {Link} from "react-router-dom";
import {ArrowBack} from "@material-ui/icons";

const MenuBackButton = ({to}) => (
  <div style={{marginTop: "10px", width: "40%"}}>
    <Link to={to}>
      <div>
        <ArrowBack
          style={{
            display: "inline-block",
            marginRight: "10px",
            marginLeft: "10px"
          }}
        />
        &nbsp;
        <p style={{display: "inline-block", position: "relative", top: "-8px"}} className="menuItemText">
          Back
        </p>
      </div>
    </Link>
  </div>
);

export default MenuBackButton;



// WEBPACK FOOTER //
// ./src/components/Sidebar/components/MenuBackButton/index.jsx